import React from "react";
import { Link } from "react-router-dom";

const About = () => {
  return (
    <div id="account-menu-container" className="global-menu responsive-page">
      <div className="ui center aligned grid global-menu-grid">
        <div className="one column row links">
          <div className="left aligned column">
            <Link to="/terms">Terms &amp; Conditions</Link>
          </div>
          <div className="left aligned column">
            <Link to="/privacy">Privacy Policy</Link>
          </div>
          <div className="left aligned column">
            <Link to="/credits">Credits</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
